import HomeController from "./HomeController";

export default HomeController;
